// extracted by mini-css-extract-plugin
export var item = "navigation-item-module--item--rghcM";
export var link = "navigation-item-module--link--hc881";